<div class="content">
    Welcome to {{ menuTitle }} .
</div>